import React from "react";

const HamburguerIcon = ({className, iconClassName}) => {
 

  return (
    
                
    <div className={`stroke-2 ${className}`}>
    
    <svg  viewBox="0 0 32 32" className={`${iconClassName}`} enableBackground="new 0 0 32 32" id="EditableLine" version="1.1" space="preserve" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
      <line fill="fill-inherit" id="XMLID_103_" stroke="stroke-inherit" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2" x1="7" x2="25" y1="16" y2="16"/>
      <line fill="fill-inherit" id="XMLID_102_" stroke="stroke-inherit" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2" x1="7" x2="25" y1="25" y2="25"/>
      <line fill="fill-inherit" id="XMLID_101_" stroke="stroke-inherit" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2" x1="7" x2="25" y1="7" y2="7"/>
    </svg>

                
    </div>       
              
             
           
  );
};

export default HamburguerIcon;